import React from 'react';
import FeedMixOptimizer from '../FeedMixOptimizer';
import NutritionalGoalTracker from '../NutritionalGoalTracker';
import FeedMixTemplateManager from '../FeedMixTemplateManager';
import type { NutritionPlansView } from './nutritionManagementNav';

interface NutritionPlansPanelProps {
  view: NutritionPlansView;
  selectedLocation: string;
  showTemplateManager: boolean;
  onCloseTemplateManager: () => void;
  onRefresh: () => void;
  onSelectTemplate?: () => void;
  onOpenInMixForm?: (initialData: Partial<import('../../api/nutrition').CreateDailyFeedMixDto>) => void;
  onCreatedForDispense?: () => void;
}

export default function NutritionPlansPanel({
  view,
  selectedLocation,
  showTemplateManager,
  onCloseTemplateManager,
  onRefresh,
  onSelectTemplate,
  onOpenInMixForm,
  onCreatedForDispense,
}: NutritionPlansPanelProps) {
  if (view === 'optimizer') {
    return (
      <FeedMixOptimizer
        onOptimize={onRefresh}
        selectedLocation={selectedLocation}
        onOpenInMixForm={onOpenInMixForm}
        onCreatedForDispense={onCreatedForDispense}
      />
    );
  }

  if (view === 'goals') {
    return <NutritionalGoalTracker selectedLocation={selectedLocation} onGoalUpdate={onRefresh} />;
  }

  return (
    <>
      <div className="rounded-lg border border-dashed border-gray-300 bg-slate-50/80 p-8 text-center">
        <p className="text-sm text-slate-600">
          Create, edit, and reuse feed mix templates. Templates speed up daily mix recording and keep formulations consistent.
        </p>
        <button
          type="button"
          onClick={() => onSelectTemplate?.()}
          className="btn btn-primary mt-4 text-sm focus-pop"
        >
          Open template manager
        </button>
      </div>
      <FeedMixTemplateManager
        isOpen={showTemplateManager}
        onClose={onCloseTemplateManager}
        onSelectTemplate={() => onCloseTemplateManager()}
        selectedComponents={[]}
      />
    </>
  );
}
